import { callApi } from 'utils/api'
import crud from './_crud'
import { useMemo } from 'react'

const actions = crud('communication_user', 'el comunicado', 'los comunicados')

const getAuthToken = (state) => {
    if (state.app.user?.token) return state.app.user.token
    if (state.app.client?.token) return state.app.client.token
    if (state.app.driver?.token) return state.app.driver.token
    if (state.app.supplier?.token) return state.app.supplier.token
    if (state.app.passenger?.token) return state.app.passenger.token
    return null
}
const getRole = (state) => {
    if (state.app.user) return 'user'
    if (state.app.client) return 'client'
    if (state.app.driver) return 'driver'
    if (state.app.supplier) return 'supplier'
    if (state.app.passenger) return 'passenger'
    return null
}


export const get_users_communication = (userId, role) => {
    return async (dispatch, getState) => {
        const state = getState()

        try {
            const res = await callApi(
                `/communication_user/utils/get_users_communications/${userId}?role=${encodeURIComponent(role)}`,
                {
                    method: 'GET',
                    headers: {
                        Authorization: state.app[role]?.token,
                        usertype: `${role}_id`
                    },
                    params: {
                        userType: role,
                        sys_company_id: state.app[role].sys_company_id,
                        userType_id: state.app[role].id,

                    },
                    shouldSkipStatusError: true
                }
            )

            if (res.status !== 200) return []

            dispatch({
                type: `LOAD_COMMUNICATION_USERS`,
                response: res.body
            })
            

            return res.body
        } catch (error) {
            console.error('Error fetching user communications:', error)
            return []
        }
    }
}

export const update_communication_selection = (id, selected) => {
    return async (dispatch, getState) => {
        const state = getState()
        const token = getAuthToken(state)
        const role = getRole(state)


        if (!token) {
            console.warn('No auth token found')
            return
        }
        if (!role) {
            console.warn('No role found')
            return
        }
        try {
            const res = await callApi(
                `/communication_user/utils/update_communication_selection/${id}`,
                {
                    method: 'PUT',
                    headers: {
                        Authorization: token,
                        'Content-Type': 'application/json',
                        usertype: `${role}_id`
                    },
                    params: {
                        userType: role,
                        sys_company_id: state.app[role].sys_company_id,
                        userType_id: state.app[role].id,

                    },
                    body: JSON.stringify({ selected, role }),
                }
            )
            return res.body
        } catch (error) {
            console.error('Error updating communication selection:', error)
            throw error
        }
    }
}


export default actions
